// see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options
export const dateToLocaleFormat = (date, locale = 'nl', options) =>
    new Intl.DateTimeFormat(
        locale,
        options || {
            dateStyle: 'full',
            timeStyle: 'short'
        }
    ).format(date instanceof Date ? date : new Date(date));

export default dateToLocaleFormat;
